class NumView {
  // ---------------------------------------------------------------------------------------------------------
  // --	NumView
  // ---------------------------------------------------------------------------------------------------------

  constructor(dom) {
    //dom参照
    this.$dom = dom;

    //初期アップデート
    this.update();
  }

  update(num = 0) {
    const numStr = String(num);
    this.$dom.find(".num").each(function (index) {
      const $num = $(this);
      const charIndex = 3 - index;
      if (3 - index <= numStr.length) {
        let src = $num.attr("src");
        src =
          src.split("pt_")[0] +
          "pt_" +
          parseInt(numStr.charAt(numStr.length - charIndex)) +
          ".svg";
        $num.attr("src", src);
        $num.show();
      } else {
        $num.hide();
      }
    });
  }

  // ---------------------------------------------------------------------------------------------------------
}

export default NumView;
